import { theme } from '@aloft/toolkit-sui';
import {
  CHART_FONT_FAMILY,
  TOOLTIP_CHAR_WIDTH,
  TOOLTIP_FONT_SIZE,
  TOOLTIP_OPACITY,
  TOOLTIP_PILL_HEIGHT,
  TOOLTIP_PILL_PADDING_X,
  TOOLTIP_VERTICAL_OFFSET,
} from '../consts.ts';
import { TooltipState } from '../types.ts';
import { formatValue } from '../utils/chartDomain.ts';

type TooltipPillProps = {
  tooltip: TooltipState;
  plotOffsetX: number;
  plotOffsetY: number;
};

export const Tooltip = ({ tooltip, plotOffsetX, plotOffsetY }: TooltipPillProps) => {
  if (!tooltip) return null;

  const text = `${tooltip.label}: ${formatValue(tooltip.value)}`;
  const pillWidth = text.length * TOOLTIP_CHAR_WIDTH + TOOLTIP_PILL_PADDING_X * 2;
  const ax = plotOffsetX + tooltip.x - pillWidth / 2;
  const ay = plotOffsetY + tooltip.y - TOOLTIP_PILL_HEIGHT - TOOLTIP_VERTICAL_OFFSET;

  return (
    <g pointerEvents="none">
      <rect
        x={ax}
        y={ay}
        width={pillWidth}
        height={TOOLTIP_PILL_HEIGHT}
        rx={4}
        ry={4}
        fill={theme.colors.selected3}
        opacity={TOOLTIP_OPACITY}
      />
      <text
        x={ax + pillWidth / 2}
        y={ay + TOOLTIP_PILL_HEIGHT / 2 + TOOLTIP_FONT_SIZE / 2 - 1}
        textAnchor="middle"
        fill="white"
        fontSize={TOOLTIP_FONT_SIZE}
        fontFamily={CHART_FONT_FAMILY}
      >
        {text}
      </text>
    </g>
  );
};
